import type { CelebrityResult } from "./types";

export const jimCornelison: CelebrityResult = {
  slug: "jim-cornelison",
  firstName: "Jim",
  lastName: "Cornelison",
  roleLines: ["National Anthem Singer", "3,000 Grafts"],
  headlineLines: ["Singing the praises", "for hair restoration"],
  intro: [
    "Jim Cornelison has been a professional anthem singer and entertainer his entire life. For years, he was a professional opera tenor. Now, he sings the National Anthem at every Chicago's hockey home game and has performed for most of Chicago's other professional sports teams.",
  ],
  heroBannerImage: {
    src: "/endorser-banners/Cornelison_website_banner_1920x800_v1.webp",
    alt: "Jim Cornelison RESTORE hair restoration results banner",
  },
  heroBannerImageMobile: {
    src: "/endorser-banners/cornelison_website_mobile_800x879_v1.webp",
    alt: "Jim Cornelison RESTORE hair restoration results banner",
  },
  heroBackground: "/img/r/wp-2024-09-restore-jim-cornelison-after-photo-083.webp",
  heroLayout: "diagonal-right",
  heroMinHeight: "700px",
  posterImage: {
    src: "/img/r/wp-2024-09-restore-jim-cornelison-after-photo-108-1.webp",
    alt: "Jim Cornelison RESTORE Hair Results",
  },
  heroBeforeAfter: {
    src: "/img/r/wp-2024-09-jim-before.webp",
    alt: "Jim Cornelison before and after hair transplant",
  },
  story: {
    video:
      "https://d17ehmrb6zqtjv.cloudfront.net/Videos/Videos+with+Captions/JimCornelison%27sStoryRESTOREHair.mp4",
    headingPrefix: "Jim Cornelison",
    headingSuffix: "Hair Transplant Journey",
    image: {
      src: "/img/r/wp-2023-03-result-athlete-jimc.webp",
      alt: "Jim Cornelison hair transplant story",
    },
    paragraphs: [
      "Jim Cornelison has been a professional anthem singer and entertainer his entire life. For years, he was a professional opera tenor. Now, he uses his incredible talent to sing the National Anthem at every Chicago Blackhawks hockey home game and Cornelison performs for most of Chicago's other professional sports teams.",
      "\u201cI'm on TV about 80 times a year and if I'm not on TV, I'm still in front of people for anthem performances,\u201d Jim said. It was on a video screen that he noticed a bald spot on the back of his head. \u201cIt was not a happy experience. Imagine what that looks like on a Jumbotron!\u201d",
      "Jim's hair had slowly been thinning over the years. He was tired of the \u201cfirsts\u201d as a balding man. \u201cThe first time a drop of rain hit the top of my bald spot. The first time I got sunburned on my head. And, yes, the first time someone made a joke, implying that I had a comb-over.\u201d",
      "While Jim isn't vain, he knows what hair loss can do to someone in the entertainment and music industry. He wanted to follow the advice of a friend, he visited RESTORE®. The consultation at RESTORE was direct, clear and professional. Jim was relieved that the doctors and staff patiently explained the F.U.E. hair restoration process, so he'd know what to expect and understand the results.",
      "Jim couldn't wait to start – and look like he did when he was younger. \u201cThe procedure is easy, non-invasive and works! You go in, you have it done and you go home.\u201d And, he was thrilled that after the procedure, the results would be natural and his hair would regrow like it did when he was younger. \u201cWhen you have hair, you look more youthful and more people can relate to you. I was excited to see the results.\u201d",
    ],
  },
  gallery: {
    images: [
      {
        src: "/img/r/wp-2021-12-jimcweb-silder-med2-1-300x275.webp",
        alt: "Jim Cornelison Hair Transplant",
      },
      {
        src: "/img/r/wp-2021-12-jimc-web-silder-sm2-1-232x300.webp",
        alt: "Jim Cornelison Hair Transplant",
      },
      {
        src: "/img/r/wp-2021-12-jimc-web-silder-1-1-232x300.webp",
        alt: "Jim Cornelison Hair Transplant",
      },
      {
        src: "/img/r/wp-2021-12-jimc-web-silder-large-1-300x192.webp",
        alt: "Jim Cornelison Hair Transplant",
      },
    ],
  },
  qa: {
    items: [
      {
        image: {
          src: "/img/r/wp-2021-12-jim-1-qa.webp",
          alt: "Jim Cornelison After Hair Transplant",
        },
        question: "What made you consider hair restoration?",
        answer:
          "I have a cousin who's about 8 years older than me with hair just like mine. Just by looking at him, I could see where my hair was headed.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-jim-3-qa.webp",
          alt: "Jim Cornelison After Hair Transplant",
        },
        question: "How does hair affect your professional prospects?",
        answer:
          "In my line of work, what you look like on camera matters. Our culture is youth-oriented and people simply relate better to someone with a full head of hair.",
      },
      {
        image: {
          src: "/img/r/wp-2021-12-jim-2-qa.webp",
          alt: "Jim Cornelison After Hair Transplant",
        },
        question: "What was your goal with the RESTORE F.U.E. procedure?",
        answer:
          "I wanted to have a full head of hair like I did 20 years ago. The fact that the RESTORE F.U.E. Method can make me look like I once did is simply amazing!",
      },
    ],
  },
  seoH1: "Jim Cornelison",
  seo: {
    title: "Jim Cornelison Hair Transplant Results | RESTORE Hair",
    description:
      "Learn why Jim Cornelison came to RESTORE to get his hair Transplant. See behind the scene photos and videos directly from Jim.",
  },
};
